import React, { useState } from "react";
import Sidebar from "../../../components/Sidebar"; // Reusing the sidebar or we could build a specific Admin sidebar. I'll use a placeholder structure.
import InviteAccountantModal from "./InviteAccountantModal";
import "./admin_dashboard.css";
import {
  FaUserPlus,
  FaEnvelope,
  FaBuilding,
  FaUserTie,
  FaSearch,
} from "react-icons/fa";

export default function AdminDashboard() {
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // Placeholder data for the accountant list
  const [accountants, setAccountants] = useState([
    {
      id: "ACC-001",
      name: "Alice Johnson",
      company: "Apex Solutions Pvt Ltd",
      email: "alice@example.com",
      phone: "9876543210",
      status: "Active",
      dateJoined: "2023-11-12",
    },
    {
      id: "ACC-002",
      name: "Bob Smith",
      company: "Smith Accounting LLC",
      email: "bob.smith@example.com",
      phone: "5551234567",
      status: "Pending",
      dateJoined: "2024-01-05",
    },
  ]);

  const filteredAccountants = accountants.filter(
    (acc) =>
      acc.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      acc.company.toLowerCase().includes(searchQuery.toLowerCase()) ||
      acc.email.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <div className="app admin-layout">
      <Sidebar />

      <main className="main">
        <header className="admin-header">
          <div className="admin-header-title">
            <h1>Admin Dashboard</h1>
            <p>Manage and invite accountants to your workspace.</p>
          </div>
          <div className="admin-header-actions">
            <button
              className="btn-invite-accountant"
              onClick={() => setIsInviteModalOpen(true)}
            >
              <FaUserPlus /> Invite Accountant
            </button>
          </div>
        </header>

        <section className="admin-content">
          <div className="admin-card">
            <div className="admin-card-header">
              <h3>Accountant Directory</h3>
              <div className="admin-search-wrap">
                <FaSearch className="search-icon" />
                <input
                  type="text"
                  placeholder="Search accountants..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>

            <div className="admin-table-container">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>NAME & EMAIL</th>
                    <th>COMPANY</th>
                    <th>PHONE</th>
                    <th>STATUS</th>
                    <th>DATE JOINED</th>
                    <th className="action-col">ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAccountants.length > 0 ? (
                    filteredAccountants.map((acc) => (
                      <tr key={acc.id}>
                        <td>
                          <div className="acc-name-block">
                            <span className="acc-name">{acc.name}</span>
                            <span className="acc-email">{acc.email}</span>
                          </div>
                        </td>
                        <td>{acc.company}</td>
                        <td>{acc.phone || "N/A"}</td>
                        <td>
                          <span
                            className={`status-badge ${acc.status.toLowerCase()}`}
                          >
                            {acc.status}
                          </span>
                        </td>
                        <td>{acc.dateJoined}</td>
                        <td className="action-col">
                          <button className="btn-table-action">View</button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="empty-state-cell">
                        No accountants found matching your search.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </main>

      {/* Invite Modal */}
      {isInviteModalOpen && (
        <InviteAccountantModal onClose={() => setIsInviteModalOpen(false)} />
      )}
    </div>
  );
}
